/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeammateAnalyticsCard_person = {
    readonly isUser: boolean;
    readonly primaryEmail: string;
    readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"CalendarStatus_person" | "CalendarTimeZone_person" | "TeammateHealthAvatar_person">;
    readonly " $refType": "TeammateAnalyticsCard_person";
};
export type TeammateAnalyticsCard_person$data = TeammateAnalyticsCard_person;
export type TeammateAnalyticsCard_person$key = {
    readonly " $data"?: TeammateAnalyticsCard_person$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeammateAnalyticsCard_person">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeammateAnalyticsCard_person",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUser",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryEmail",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "familyName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalImageUrl",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarStatus_person"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarTimeZone_person"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeammateHealthAvatar_person"
        }
    ],
    "type": "Person",
    "abstractKey": null
} as any;
(node as any).hash = '61ace6560658711c2ac92fffe90512ff';
export default node;
